export const bones = ['femur', 'fibula', 'patella', 'tibia'] as const;

export type Bone = (typeof bones)[number];
